import { pad3, sortNumericAsc } from "@tedivo/tedivo-pure-helpers";
import { ForeAftEnum } from "open-vessel-definition";
import { createSvgText } from "./createSvgText";
import { handleDoubleClick } from "@tedivo/tedivo-dom-helpers";
export function createSvgTopBayNumbers({ blps, lcgsBy20Bay, svgNode, xPos, fontColor, fontSize = 8, onDoubleClick, doNotRepeatBays, }) {
    const blpsByBay = {};
    blps.forEach((blp) => {
        blpsByBay[blp.isoBay] = blp;
    });
    const allBays = Object.keys(lcgsBy20Bay).sort(sortNumericAsc);
    const midTopNumbers = new Set();
    const svgG = document.createElementNS("http://www.w3.org/2000/svg", "g");
    svgG.classList.add("top-bay-numbers");
    allBays
        .filter((bay) => {
        return !doNotRepeatBays || !(doNotRepeatBays === null || doNotRepeatBays === void 0 ? void 0 : doNotRepeatBays.has(bay));
    })
        .forEach((bay) => {
        var _a, _b;
        doNotRepeatBays === null || doNotRepeatBays === void 0 ? void 0 : doNotRepeatBays.add(bay);
        const lcgsBy20OfBay = lcgsBy20Bay[bay];
        const x = (_a = lcgsBy20OfBay.lcgs.get(20)) === null || _a === void 0 ? void 0 : _a.lcg;
        if (x === undefined)
            return;
        if (lcgsBy20OfBay.confirmedPairedBay) {
            const evenBay = pad3(Math.round((Number(bay) + Number(lcgsBy20OfBay.confirmedPairedBay)) / 2));
            const evenX = (_b = lcgsBy20Bay[lcgsBy20OfBay.confirmedPairedBay].lcgs.get(20)) === null || _b === void 0 ? void 0 : _b.lcg;
            if (evenX !== undefined && !midTopNumbers.has(evenBay)) {
                const midX = (x + evenX) / 2;
                const smFontSize = Math.round(fontSize * 1.25);
                const midBayNumberSvgText = createSvgText({
                    text: evenBay,
                    x: xPos(midX, 2),
                    y: Math.round(smFontSize * 1.7),
                    fontSize: smFontSize,
                    textAnchor: "middle",
                    textColor: fontColor || "#aaa",
                });
                midBayNumberSvgText.dataset["bay"] = bay;
                midBayNumberSvgText.style.fontFamily = "Arial, sans-serif";
                midBayNumberSvgText.classList.add("top-bay-number");
                svgG.appendChild(midBayNumberSvgText);
                if (onDoubleClick) {
                    handleDoubleClick(midBayNumberSvgText, onDoubleClick);
                }
                midTopNumbers.add(evenBay);
            }
        }
        if (x !== undefined) {
            const bayNumberSvgText = createSvgText({
                text: getDecoratedIsoNumber(blpsByBay[bay] || bay),
                x: xPos(x, 2),
                y: fontSize,
                fontSize,
                textAnchor: "middle",
                textColor: fontColor || "#aaa",
            });
            bayNumberSvgText.dataset["bay"] = bay;
            bayNumberSvgText.style.fontFamily = "Arial, sans-serif";
            bayNumberSvgText.classList.add("top-bay-number");
            svgG.appendChild(bayNumberSvgText);
            if (onDoubleClick) {
                handleDoubleClick(bayNumberSvgText, onDoubleClick);
            }
        }
    });
    function getDecoratedIsoNumber(blp) {
        if (typeof blp === "string")
            return blp;
        if (blp.pairedBay) {
            return blp.pairedBay === ForeAftEnum.FWD
                ? `${blp.isoBay}&middot;`
                : `&middot;${blp.isoBay}`;
        }
        return blp.isoBay;
    }
    svgNode.appendChild(svgG);
}
